export default __webpack_public_path__ + "static/media/gigly-icon.0e0bbe3f.png";